export default __webpack_public_path__ + "static/media/logo-white.48dfe956.svg";